// src/App.js
import React from 'react';
import Navbar from './components/nav';
import Hero from './components/hero';
import AboutSection from './components/aboutUs';
import QuoteSection from './components/servicios';
import Testimonials from './components/testimonios';
import GalleryAcordion from './components/galeria-acordion';
import ContactInfo from './components/contacto';
import Footer from './components/footer';

function App() {
  // Alterna visibilidad del menú móvil
  const toggleMobileMenu = () => {
    const menu = document.getElementById('mobile-menu');
    if (menu) {
      menu.classList.toggle('hidden');
    }
  };

  // Desplaza suavemente hasta la sección de contacto
  const scrollToContact = (e) => {
    e.preventDefault();
    const el = document.getElementById('contacto');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="font-principal">
      <Navbar />

      <Hero />
      <AboutSection />
      <div className="section-separator" />
      <QuoteSection />

      {/* ← Aquí insertamos el primer separador */}
      <div className="section-separator" />

      <GalleryAcordion />
      <div className="section-separator" />
      <Testimonials />
      <div className="section-separator" />
      <ContactInfo />

      

      <Footer/>
    </div>
  );
}

export default App;
